<template>
  <section id="step-2">
    <div class="row">
      <Form
        class="col-lg-8"
        @submit="nextStep"
        @invalid-submit="onInvalidSubmit"
      >
        <h1>{{ $t('Delivery data') }}</h1>
        <div class="listing">
          <DeliveryFields />
        </div>
        <div class="hidden-md-up">
          <Summary />
        </div>
        <div class="pagination">
          <PaginationButton
            type="prev"
            :text="$t('Back to cart')"
          />
          <button
            type="submit"
            class="next"
          >
            {{ $t("Shipping and payment") }}
            <span class="arrow">&#8594;</span>
          </button>
        </div>
        <div class="hidden-md-up">
          <Help />
        </div>
      </Form>
      <div class="col-lg-4 hidden-md-down">
        <Summary />
        <Help />
      </div>
    </div>
  </section>
</template>
<script>
import { Form } from 'vee-validate'
import { mapMutations } from 'vuex'
import { useToast } from 'vue-toastification'
import useCart from '../useCart'
import Summary from '../Partials/Summary'
import PaginationButton from '../Partials/PaginationButton'
import Help from '../Partials/Help'
import DeliveryFields from '../Partials/DeliveryFields'
import { scrollToSection } from '../../../../helpers'

export default {
  components: {
    Form,
    PaginationButton,
    DeliveryFields,
    Summary,
    Help,
  },
  methods: {
    ...mapMutations('cart', [
      'INCREMENT_STEP',
    ]),
    onInvalidSubmit({ values, errors, results }) {
      this.toast.error(this.$t('fill_text_fields'))

      scrollToSection('#app')
    },
    nextStep() {
      this.setCartLocalStorage()

      this.INCREMENT_STEP()
    },
  },
  setup() {
    const toast = useToast()
    const {
      updateCartStep,
      setCartLocalStorage,
    } = useCart()

    return {
      toast,
      updateCartStep,
      setCartLocalStorage,
    }
  },
  mounted() {
    this.updateCartStep(2)
  },
}
</script>
